import React from "react";

import { PageMain } from "components/molecules";
import { PaziaHeader } from "components/atoms/PaziaHeader/PaziaHeader";
// import { ChangelogFilters } from "./ChangelogFilters";
import { Article20240909 } from "./articles/Article20240909";
import { Article20240910 } from "./articles/Article20240910";
import { Article20240910_2 } from "./articles/Article20240910_2";
import { Article20240921 } from "./articles/Article20240921";
import { Article20241006 } from "./articles/Article20241006";
import { Article20241103 } from "./articles/Article20241103";
import { Article20241121 } from "./articles/Article20241121";

export const CURRENT_VERSION_NO = "1.5.0";
export const VersionsPage = (): JSX.Element | null => {
  return (
    <PageMain>
      <PaziaHeader>Wersje aplikacji</PaziaHeader>
      <main className="grow">
        <div className="max-w-9xl mx-auto w-full px-4 py-8 sm:px-6 lg:px-8">
          <div className="border-t border-slate-200 dark:border-slate-700">
            <div className="m-auto mt-8 max-w-3xl">
              {/* <ChangelogFilters /> */}

              <Article20241121 />
              <Article20241103 />
              <Article20241006 />
              <Article20240921 />
              <Article20240910_2 />
              <Article20240910 />
              <Article20240909 />

              {/* Pagination */}
              {/* <div className="xl:pl-32 xl:-translate-x-16 mt-6">
                  <PaginationClassic />
                </div> */}
            </div>
          </div>
        </div>
      </main>
    </PageMain>
  );
};
